import bulkScripts from "./bulkScripts.component";
import bulkScriptsUrls from "./bulkScripts.urls";
import BulkScriptsTransforms from "./bulkScripts.transforms";

const bulkScriptsModule = angular
  .module("app.components.bulkScripts", [])
  .component("bulkScriptsPage", bulkScripts)
  .service("BulkScriptsTransforms", BulkScriptsTransforms)
  .config(bulkScriptsUrls);

export default bulkScriptsModule;



// WEBPACK FOOTER //
// ./src/pages/bulkScripts/bulkScripts.module.js